<ng-template #spinner>
   <mat-spinner diameter="30"></mat-spinner>
</ng-template>

<div class="report" *ngIf="report">
   <div class="flex buttons">
      <ng-container *ngIf="!_saving else spinner">
         <div>
            <button mat-raised-button color="primary" [disabled]="reportForm.invalid || !reportForm.get('name').value || !filters.valid || !fields.valid" (click)="save()">
               <mat-icon>save</mat-icon> SAVE
            </button>

            <button mat-raised-button color="primary" [disabled]="(reportForm.invalid && !reportForm.get('name').errors) || !filters.valid || !fields.valid" (click)="run()" class="common-ml1em preview-button">
               <mat-icon>trending_up</mat-icon> {{(reportForm.get('name').value.trim() ? 'SAVE AND RUN' : 'PREVIEW')}}
            </button>

            <button mat-raised-button color="primary" [disabled]="!report.id" (click)="schedule()" class="common-ml1em preview-button">
               <mat-icon>calendar_today</mat-icon> SCHEDULING
            </button>
         </div>

         <ng-container *ngIf="report.id">
            <button mat-raised-button color="warn" (click)="_delete = !_delete" *ngIf="!_delete">
               <mat-icon>delete</mat-icon> DELETE
            </button>
            <div *ngIf="_delete" class="delete-check">
               <span>Are you sure?</span>
               <button mat-raised-button (click)="delete()" color="warn">Yes</button>
               <button mat-button (click)="_delete = false">No</button>
            </div>
         </ng-container>
      </ng-container>
   </div>

   <div class="details">
      <mat-form-field class="common-minw50ex" *ngIf="reportForm.get( 'name' ) as name">
         <mat-label>Report Name</mat-label>
         <input matInput [formControl]="name" [required]="true" pattern="" maxlength="50" />
         <mat-error libInputErrors [control]="name"></mat-error>
         <button matSuffix mat-icon-button (click)="name.reset()" *ngIf="name.value">
            <mat-icon>clear</mat-icon>
         </button>
      </mat-form-field>

      <ng-container *ngIf="reportForm.get( 'name' ).value">
         <div *ngIf="reportForm.get( 'shared' ) as shared">
            Share report?
            <mat-radio-group (change)="shared.setValue( $event.value )">
               <mat-radio-button value="true"  class="common-ml1em" [checked]="shared.value">Yes</mat-radio-button>
               <mat-radio-button value="false" class="common-ml1em" [checked]="!shared.value">No</mat-radio-button>
            </mat-radio-group>
         </div>
      </ng-container>

      <div class="details-footer" *ngIf="report.last_updated">
         Last Updated {{report.last_updated | date}}
      </div>
   </div>

   <lib-report-filters #filters></lib-report-filters>

   <lib-report-fields #fields></lib-report-fields>
</div>
